import React from 'react';

import Context from '../../../../../../context';

import {
  CustomModal,
  CustomButton2,
  ResponsiveView,
} from '../../../../../../components';

import './index.sass';

const Delete: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { showModal, setShowModal, isLoading, deleteFunction } = React.useContext(Context.Location.Neighborhood);

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  async function onClickDelete(): Promise<void> {
    await deleteFunction!();
  }

  function onClickCancel(): void {
    setShowModal!('NONE');
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id="parent-update-modal-container">
      <CustomModal label='حذف محله' open={showModal === 'DELETE'} onClose={onClickCancel}>
        <ResponsiveView.Container className="create-form-content">
          <br/>
          <span>آیا از حذف این محله اطمینان دارید ؟</span>
          <hr/>
          <ResponsiveView.Row className="form-row">
            <ResponsiveView.Column large={6} medium={6} small={12}>
              <CustomButton2 isLoading={isLoading} onClick={onClickCancel} title={'لغو'} type='primary'/>
            </ResponsiveView.Column>
            <ResponsiveView.Column large={6} medium={6} small={12}>
              <CustomButton2 isLoading={isLoading} onClick={onClickDelete} title={'حذف'} type='danger' />
            </ResponsiveView.Column>
          </ResponsiveView.Row>
        </ResponsiveView.Container>
      </CustomModal>
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default Delete;
